var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MascotaComponent',{attrs:{"component_usuario_uq":_vm.component_usuario_uq}})}
var staticRenderFns = []

export { render, staticRenderFns }